import Button from '@/components/public/ui/Button';
import Container from '@/components/public/ui/Container';
import { trackUmamiEvent } from '@/lib/analytics';
import { parishName, parishShortName, parishLogo, useSite } from '@/hooks/useSite';

// Light, compact hero. The brasão crest panel is the trust anchor; the task
// grid (QuickAccessHub) sits right beneath, near the fold. No full-screen
// height, no floating card, no float animation.
const HeroHome = () => {
  const site = useSite();
  return (
    <section className="relative overflow-hidden">
      <Container className="grid grid-cols-1 items-center gap-10 pt-12 pb-14 md:pt-16 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16 lg:pt-20 lg:pb-20">
        {/* Left column */}
        <div data-rise>
          <p className="text-tertiary mb-5 inline-flex items-center gap-2 text-xs font-bold tracking-[0.14em] uppercase">
            <span className="bg-tertiary h-px w-6" />
            Ao serviço da freguesia
          </p>
          <h1 className="font-headline text-on-surface text-4xl font-semibold sm:text-5xl lg:text-6xl">
            A sua freguesia,
            <br />
            <em className="text-primary font-medium italic">mais perto de si.</em>
          </h1>
          <p className="text-on-surface-light mt-6 max-w-xl text-lg">
            Descubra os serviços, eventos e a história da {parishName(site)}.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button
              variant="primary"
              size="lg"
              href="/services"
              iconAfter="arrow_forward"
              onClick={() =>
                trackUmamiEvent('home_cta_click', {
                  label: 'Explorar Serviços',
                  target: '/services',
                })
              }
            >
              Explorar Serviços
            </Button>
            <Button
              variant="ghost"
              size="lg"
              href="/events"
              onClick={() =>
                trackUmamiEvent('home_cta_click', { label: 'Ver Agenda', target: '/events' })
              }
            >
              Ver Agenda
            </Button>
          </div>
        </div>

        {/* Right column — brasão crest panel */}
        <div className="relative hidden lg:block" data-rise style={{ animationDelay: '0.12s' }}>
          <div className="surface-card-elevated relative mx-auto flex aspect-square max-w-md items-center justify-center overflow-hidden rounded-2xl">
            <div className="card-gradient-secondary absolute inset-0" />
            <div className="border-line-strong pointer-events-none absolute inset-5 rounded-xl border" />
            <img
              src={parishLogo(site)}
              alt={`Brasão de ${parishName(site)}`}
              className="relative w-[58%] drop-shadow-[0_8px_20px_rgba(33,29,24,0.18)]"
            />
            <div className="section-ink absolute inset-x-0 bottom-0 py-3 text-center">
              <span className="font-headline text-[13px] tracking-[0.22em] text-[#efe8da] uppercase">
                {parishShortName(site)}
              </span>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HeroHome;
